import { CronScheduleVariables } from '@smartlife-redux-state/common';
import { TimeSelector } from '../../components/TimeSelector';

// eslint-disable-next-line import/prefer-default-export
export const CronScheduler: React.FC<{
  variables: CronScheduleVariables;
  onChange: (variables: CronScheduleVariables) => void;
}> = ({ variables, onChange }) => <TimeSelector variables={variables} onChange={onChange} />;
